export default {
	"forexceptcreate": {
		"keywords": "关键词"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/forexcept/forexcept.js